import React, { useEffect, useRef } from 'react';
import 'flatpickr/dist/themes/material_green.css';
import Flatpickr from 'flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es.js';

/** Visual DD/MM/YYYY with calendar button; state and API remain YYYY-MM-DD. */
export default function AccountingDatePicker({ value = '', onChange, min, max, className = '', ...props }) {
    const inputRef = useRef(null);
    const pickerRef = useRef(null);
    const callbackRef = useRef(onChange);
    callbackRef.current = onChange;

    useEffect(() => {
        const picker = Flatpickr(inputRef.current, {
            locale: Spanish, dateFormat: 'Y-m-d', altInput: true, altFormat: 'd/m/Y',
            allowInput: false, disableMobile: true, clickOpens: true,
            defaultDate: value || undefined, minDate: min || undefined, maxDate: max || undefined,
            onChange: (_dates, dateString) => callbackRef.current?.(dateString),
        });
        pickerRef.current = picker;
        return () => { picker.destroy(); pickerRef.current = null; };
    }, []);
    useEffect(() => {
        const picker = pickerRef.current;
        if (picker && picker.input.value !== (value || '')) picker.setDate(value || '', false, 'Y-m-d');
    }, [value]);
    useEffect(() => { pickerRef.current?.set('minDate', min || null); }, [min]);
    useEffect(() => { pickerRef.current?.set('maxDate', max || null); }, [max]);

    return <div className={`accDateField ${className}`}>
        <input ref={inputRef} type="text" aria-label={props['aria-label'] || 'Seleccionar fecha'} {...props} />
        <button className="accDateTrigger" type="button" aria-label="Abrir calendario" title="Abrir calendario"
            onClick={() => pickerRef.current?.open()}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/><path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01"/>
            </svg>
        </button>
    </div>;
}
